module.exports = __webpack_public_path__ + "static/media/exotics.b07673a0.jpg";